import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from 'sb-react-intl'

import FooterNav from 'components/layout/Footer/FooterView/ExceptMobile/FooterNav/FooterNav'
import FooterColumnTitle from 'components/layout/Footer/FooterView/ExceptMobile/FooterColumnTitle/FooterColumnTitle'


const FooterShop = ({ title, nav }) => (
  <div>
    <FooterColumnTitle>
      <FormattedMessage {...title} />
    </FooterColumnTitle>
    <FooterNav items={nav} arieLabel="Shop" />
  </div>
)

FooterShop.propTypes = {
  title: PropTypes.object.isRequired,
}

export default FooterShop
